import styled from 'styled-components';

export const ConfirmModal = styled.header`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  grid-template-areas: 
    "confirmCall confirmCall"
    "cancel submit";
`

export const ConfirmModalCall = styled.p`
  grid-area: confirmCall;
`